__turbopack_context__.v({
  "border-shine": "MainButton-module__VwCPOq__border-shine",
  "shadow-pulse": "MainButton-module__VwCPOq__shadow-pulse",
  "techButton": "MainButton-module__VwCPOq__techButton",
  "techButtonBorder": "MainButton-module__VwCPOq__techButtonBorder",
  "techButtonContent": "MainButton-module__VwCPOq__techButtonContent",
  "techButtonWrapper": "MainButton-module__VwCPOq__techButtonWrapper",
});
